module.exports = __webpack_public_path__ + "img/24.f34adeb4.jpg";